import { gql } from "@apollo/client";

export const GET_ACTIVE_RESERVATIONS_WITH_VMS = gql`
  query GetActiveReservationsWithLinkedVms {
    getActiveReservationsWithLinkedVms {
      displayName
      vmType
      purchaseDateTime
      expiryDateTime
      linkedVms {
        vmName
      }
    }
  }
`;
